import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  generalContainer: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    color: 'common.black',
    height: '100vh',
  },

  featuresContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  singleFeatureContainer: {
    justifyContent: 'space-arround',
  },

  getStartedButton: {
    mr: '10px',
  },

  reviewCard: {
    backgroundColor: 'white_color.5004',
    width: '276px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '24px',
    mb: '24px',

    [theme.breakpoints.down('sm')]: {
      width: '335px',
    },
  },

  rCardWhiteText: {
    color: 'white',
    mb: '10px',
  },

  rCardGreyText: {
    color: 'grey.500',
    mb: '10px',
  },

  rCardIcon: {
    width: '90px',
    height: '18px',
    color: 'warning.main',
    mb: '10px',
  },

  rCardWhite: {
    color: 'white',
  },
});
